import React, { Component } from 'react'
import $ from 'jquery'
import kendo from '@progress/kendo-ui'
import { Grid as KendoGrid, GridColumn as Column } from '@progress/kendo-grid-react-wrapper'
import API_URL from 'utils/ApiUrl'
import language from 'utils/vast-languagepack'

export default class SentMessagesAndStats extends Component {

  render() {


    const jwtToken = this.props.jwtToken
    const templatesById = this.props.templatesById

    const detailInit = function(e) {
      const id = e.data.id
      const url = `${API_URL}/email/schedule/${id}/stats`
      $("<div/>").appendTo(e.detailCell).kendoGrid({
          dataSource: {
              dataType: "jsonp",
               schema: {
                              model: {
                                  fields: {
                                      id: { type: "number" },
                                  }
                              }
                          },
              transport: {
                  read: {
                    url: url,
                    beforeSend: function(xhr){xhr.setRequestHeader('authorization', `Bearer ${jwtToken}`)}
                              }
                          },

                          // filter: { field: "id", operator: "eq", value: id }
                      },
                      scrollable: false,
                  })
    }
    const  dataSource = new kendo.data.DataSource({
      dataType: "jsonp",
      transport: {
          read: {
            url: `${API_URL}/email/completed`,
            beforeSend: function(xhr){xhr.setRequestHeader('authorization', `Bearer ${jwtToken}`)}
          }
      },


  })
  const render_template_name = function(item){
    console.log("item:",item)
    console.log("this",this)

    return templatesById && templatesById[item.id] ?
      templatesById[item.id].Template.TemplateName :
      item.id
  }

    if (jwtToken !=null){
        return (
          <div>
          <h1>{language.emailPage.sentMessagesStats}</h1>
          <KendoGrid dataSource={dataSource}
              // scrollable={true} height={600}
              // groupable={true}
              // pageable={true}
              detailInit={detailInit}
              >              <Column field="when_to_send" title={language.emailPage.labels.dateSent}  />
              <Column field="trigger_data" title={language.emailPage.labels.templateId} template ={render_template_name}/>
          </KendoGrid>
          </div>
      )
    }
    return (
      <div>
        Missing Jwt Token
      </div>
      )
  }

}
